import {ExportOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import React from 'react';

/**
 * Opens a Google search for the product in a new tab, like the "/ ASIN" link in the
 * product list. Searches by ASIN, or by the product name when there is none.
 */
export const FindProductLink: React.FC<{asin?: string | null; name: string}> = ({asin, name}) => {
    const query = asin?.trim() || name.trim();
    return (
        <Tooltip title={`Find Product: ${query}`}>
            <a
                href={`https://www.google.com/search?q=${encodeURIComponent(query)}`}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
                style={{whiteSpace: 'nowrap'}}
            >
                {asin ? ' / ASIN ' : ' '}
                <ExportOutlined style={{fontSize: 11}} />
            </a>
        </Tooltip>
    );
};
